{
  "endTime": "Bitiş saati",
  "startTime": "Başlangıç saati",
  "time": "Saat"
}
